import React, { useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {Grid, TextFieldForm, Typography, WordCountArea} from 'web-library';
import ControlledAutocomplete from '../../../../components/form-items/ControlledAutocomplete';
import { FormUpdateApplication } from '../../../../models';
import {
  ErrorObject,
  FormIds,
} from '../../../accessArrangment/components/candidate/SelectCondition/components/SelectConditionContent';

interface IOpsAdminApplicationStatus {
  classes: any;
  dropdownOptions: { code: string; description: string }[];
  formHook: UseFormReturn<FormUpdateApplication>;
}

const TextFieldWithRemainingCharacters = ({
  classes,
  value,
  t,
  form,
  onChange,
  maxCharacterCount,
  name,
  label,
  placeholder,
  errMsg,
}: any) => {
  const [remainingCharacter, setRemainingCharacter] = useState(maxCharacterCount);

  useEffect(() => {
    if (value && value !== '') {
      setRemainingCharacter(maxCharacterCount - value.length);
    } else {
      setRemainingCharacter(maxCharacterCount);
    }
  }, [maxCharacterCount, value]);
  const [textFieldFormErrors, setTextFieldFormErrors] = useState<ErrorObject[]>([]);

  useEffect(() => {
    const textFieldErrors: ErrorObject[] = [];
    if (remainingCharacter < 0) {
      textFieldErrors.push({
        id: FormIds.OTHERS_TEXT_AREA_OVER_LIMIT,
        text:
          t('accessArrangement->>SelectCondition.OthersStringExccedError1') +
          (0 - remainingCharacter) +
          t('accessArrangement->>SelectCondition.OthersStringExccedError2'),
      });
    }
    setTextFieldFormErrors(textFieldErrors);
  }, [remainingCharacter, t]);

  const findError = (errorId: string, textformErrors: ErrorObject[]) =>
    textformErrors.find((textformError) => textformError.id === errorId);

  const overLimitError = findError(FormIds.OTHERS_TEXT_AREA_OVER_LIMIT, textFieldFormErrors)?.text;
  const generateHelperText = () => {
    if (overLimitError) {
      return overLimitError;
    }
    return (
      remainingCharacter.toString() + t('accessArrangement->>SelectCondition.CharactersRemaining')
    );
  };
  return (
    <TextFieldForm
        form={form}
      name={name}
      className={classes.inputSection}
      multiline
      label={label}
      placeholder={placeholder}
      rows={3}
      helperText={
        <span className={overLimitError ? classes.error : ''}>{generateHelperText()}</span>
      }
      inputProps={{
        maxLength: maxCharacterCount,
      }}
      error={errMsg}
      onChange={onChange}
    />
  );
};

const OpsAdminApplicationStatusForm = ({
  classes,
  dropdownOptions,
  formHook,
}: IOpsAdminApplicationStatus) => {
  const { t } = useTranslation();
  const { watch, formState:{errors}, control } = formHook;
  const { internalRemarks: internalText, candidateRemarks: candidateText } = watch();

  return (
    <Grid container direction="column">
      <Typography variant="h3" className={classes.subheader}>
        {t('exam->>NonNationalExam.ApplicationStatus')}
      </Typography>
      <Grid md={4} sm={12}>
        <ControlledAutocomplete
          name="applicationStatus"
          control={control}
          label={t('exam->>NonNationalExam.Status')}
          options={dropdownOptions}
          getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
          className={classes.inputSection}
          placeholder="Select application status"
          error={!!errors.applicationStatus}
          helperText={errors?.applicationStatus?.message?.toString()}
          disableClearable
          readOnly
        />
      </Grid>
      <Grid md={6} sm={12}>
        <WordCountArea
            form={formHook}
            name="internalRemarks"
            error={!!errors.internalRemarks}
            label={t('exam->>NonNationalExam.Internal')}
            placeholder={t('exam->>NonNationalExam.EnterRemarks')}
            maxLength={1000}
            minRows={3}
            // CPEPOKPNEH-3391
            onChange={(e) => {
                const trimmedValue = e.target.value.slice(0, 1000); // enforce maxLength
                formHook.setValue('internalRemarks', trimmedValue);
            }}
            className={classes.inputSection}
        />

      </Grid>
      <Grid md={6} sm={12}>
        <WordCountArea
            form={formHook}
            name="candidateRemarks"
            error={!!errors.candidateRemarks}
            label={t('exam->>NonNationalExam.Candidate')}
            placeholder={t('exam->>NonNationalExam.EnterRemarks')}
            maxLength={1000}
            minRows={3}
            // CPEPOKPNEH-3391
            onChange={(e) => {
                const trimmedValue = e.target.value.slice(0, 1000); // enforce maxLength
                formHook.setValue('candidateRemarks', trimmedValue);
            }}
            className={classes.inputSection}
        />
      </Grid>
    </Grid>
  );
};

export default OpsAdminApplicationStatusForm;
